(() => {
  'use strict';

  const config = window.BBDBogoConfig || {};
  const eligible = new Set((config.variantIds || []).map(String));
  const limited = new Set((config.limitedVariantIds || []).map(String));
  if ((!eligible.size && !limited.size) || window.__bbdBogoInstalled) return;
  window.__bbdBogoInstalled = true;

  const nativeFetch = window.fetch.bind(window);
  const cartPath = (path) => {
    try { return new URL(path, location.origin).pathname; }
    catch (_) { return ''; }
  };
  const int = (value, fallback = 1) => {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) && parsed >= 0 ? parsed : fallback;
  };
  const paired = (requested, current = 0) => {
    requested = int(requested, 0);
    current = int(current, 0);
    if (requested === 0 || requested % 2 === 0) return requested;
    return requested > current ? requested + 1 : Math.max(0, requested - 1);
  };
  const cloneInit = (init) => ({ ...(init || {}), headers: new Headers((init && init.headers) || {}) });

  const OFFER_ID = 'bbd-bogo-product-offer';
  const TITLE_OFFER_ID = 'bbd-bogo-title-offer';
  const DESCRIPTION_OFFER_ID = 'bbd-bogo-description-offer';
  const OFFER_STYLE_ID = 'bbd-bogo-product-offer-style';

  function selectedProductVariant() {
    const form = document.querySelector('form[action*="/cart/add"]');
    const input = form && form.querySelector('[name="id"]');
    return { form, id: String((input && input.value) || '') };
  }

  function installOfferStyles() {
    if (document.getElementById(OFFER_STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = OFFER_STYLE_ID;
    style.textContent = `
      #${OFFER_ID} {
        margin: 0 0 16px; padding: 14px 16px; border: 2px solid #b42318;
        border-radius: 8px; background: #fff7ed; color: #1f2937;
        box-shadow: 0 2px 8px rgba(180, 35, 24, .10);
      }
      #${TITLE_OFFER_ID} {
        display: flex; align-items: center; gap: 10px; width: 100%; box-sizing: border-box;
        margin: 10px 0 14px; padding: 11px 14px; border-radius: 7px;
        background: #b42318; color: #fff; box-shadow: 0 2px 7px rgba(180, 35, 24, .18);
        font-size: 17px; font-weight: 800; line-height: 1.3; letter-spacing: .01em;
      }
      #${TITLE_OFFER_ID} .bbd-bogo-title-offer__icon {
        display: inline-flex; align-items: center; justify-content: center;
        flex: 0 0 19px; width: 19px; height: 19px; border-radius: 50%;
        background: #fff; color: #b42318; font: 800 12px/1 Arial, sans-serif;
      }
      #${DESCRIPTION_OFFER_ID} {
        margin: 0 0 20px; padding: 16px 18px; border-radius: 8px;
        background: #b42318; color: #fff; box-shadow: 0 2px 8px rgba(180, 35, 24, .14);
      }
      #${DESCRIPTION_OFFER_ID} strong {
        display: block; margin-bottom: 5px; color: #fff; font-size: 18px;
        font-weight: 800; line-height: 1.3;
      }
      #${DESCRIPTION_OFFER_ID} span {
        display: block; color: #fff; font-size: 15px; font-weight: 600; line-height: 1.5;
      }
      #${OFFER_ID} .bbd-bogo-offer__title {
        display: flex; align-items: center; gap: 8px; margin: 0 0 7px;
        color: #b42318; font-size: 18px; font-weight: 800;
        line-height: 1.2; letter-spacing: .02em;
      }
      #${OFFER_ID} .bbd-bogo-offer__icon {
        display: inline-flex; align-items: center; justify-content: center;
        flex: 0 0 22px; width: 22px; height: 22px; border-radius: 50%;
        background: #b42318; color: #fff; font: 800 14px/1 Arial, sans-serif;
      }
      #${OFFER_ID} .bbd-bogo-offer__copy {
        display: block; margin: 0; font-size: 15px; font-weight: 650; line-height: 1.45;
      }
      #${OFFER_ID} .bbd-bogo-offer__detail {
        display: block; margin-top: 3px; font-size: 14px; line-height: 1.4;
      }
      #${OFFER_ID} .bbd-bogo-offer__action {
        display: block; margin-top: 8px; padding-top: 8px;
        border-top: 1px solid rgba(180, 35, 24, .25); color: #7c2d12;
        font-size: 14px; font-weight: 800; line-height: 1.35;
      }
      @media (max-width: 767px) {
        #${TITLE_OFFER_ID} { margin: 8px 0 12px; padding: 10px 12px; font-size: 15px; }
        #${DESCRIPTION_OFFER_ID} { padding: 14px 15px; }
        #${DESCRIPTION_OFFER_ID} strong { font-size: 17px; }
        #${DESCRIPTION_OFFER_ID} span { font-size: 14px; }
        #${OFFER_ID} { margin-bottom: 12px; padding: 12px 14px; }
        #${OFFER_ID} .bbd-bogo-offer__title { font-size: 17px; }
        #${OFFER_ID} .bbd-bogo-offer__copy { font-size: 14px; }
      }
    `;
    document.head.appendChild(style);
  }

  function renderProductOffer() {
    if (!/\/products\//.test(location.pathname)) return;
    const { form, id } = selectedProductVariant();
    const existing = document.getElementById(OFFER_ID);
    const existingTitleOffer = document.getElementById(TITLE_OFFER_ID);
    const existingDescriptionOffer = document.getElementById(DESCRIPTION_OFFER_ID);
    const descriptionTarget = document.querySelector(
      '.m-product-description, .product__description, .product-description, [data-product-description]'
    );
    if (!form || !eligible.has(id)) {
      if (existing) existing.remove();
      if (existingTitleOffer) existingTitleOffer.remove();
      if (existingDescriptionOffer) existingDescriptionOffer.remove();
      return;
    }
    if (existing && existing.dataset.variantId === id && existingTitleOffer && existingTitleOffer.dataset.variantId === id && (!descriptionTarget || (existingDescriptionOffer && existingDescriptionOffer.dataset.variantId === id))) return;
    if (existing) existing.remove();
    if (existingTitleOffer) existingTitleOffer.remove();
    if (existingDescriptionOffer) existingDescriptionOffer.remove();
    installOfferStyles();

    const title = document.querySelector(
      '.m-product-info--wrapper h1, .product__title h1, h1.product__title, .product-info__title, main h1'
    );
    if (title && title.parentNode) {
      const titleOffer = document.createElement('div');
      titleOffer.id = TITLE_OFFER_ID;
      titleOffer.dataset.variantId = id;
      titleOffer.setAttribute('role', 'note');
      titleOffer.setAttribute('aria-label', 'Buy one get one free. Add one pack and receive two packs.');
      titleOffer.innerHTML = `<span class="bbd-bogo-title-offer__icon" aria-hidden="true">i</span><span>BUY 1, GET 1 FREE &nbsp;·&nbsp; ADD 1 PACK, RECEIVE 2</span>`;
      title.insertAdjacentElement('afterend', titleOffer);
    }

    if (descriptionTarget) {
      const descriptionOffer = document.createElement('aside');
      descriptionOffer.id = DESCRIPTION_OFFER_ID;
      descriptionOffer.dataset.variantId = id;
      descriptionOffer.setAttribute('aria-label', 'Buy one get one free offer details');
      descriptionOffer.innerHTML = `
        <strong>BUY 1, GET 1 FREE</strong>
        <span>Add 1 pack to your cart and we will automatically add a second identical pack FREE. Your cart will show 2 packs, but you pay for only 1. No code needed.</span>
      `;
      descriptionTarget.insertBefore(descriptionOffer, descriptionTarget.firstChild);
    }

    const offer = document.createElement('section');
    offer.id = OFFER_ID;
    offer.dataset.variantId = id;
    offer.setAttribute('aria-label', 'Buy one get one free offer');
    offer.innerHTML = `
      <strong class="bbd-bogo-offer__title"><span class="bbd-bogo-offer__icon" aria-hidden="true">i</span> BUY 1, GET 1 FREE</strong>
      <span class="bbd-bogo-offer__copy">Add 1 pack to your cart — we automatically add a second identical pack FREE.</span>
      <span class="bbd-bogo-offer__detail">Your cart will show 2 packs, but you pay for only 1. No code needed.</span>
      <span class="bbd-bogo-offer__action">ADD 1 TO CART &nbsp;→&nbsp; RECEIVE 2 PACKS</span>
    `;
    const submit = form.querySelector('[type="submit"], button[name="add"]');
    if (submit) {
      const wrapper = submit.closest('.m-product-form--wrapper, .product-form__buttons, .product-form__actions') || submit;
      wrapper.parentNode.insertBefore(offer, wrapper);
    } else {
      form.insertBefore(offer, form.firstChild);
    }
  }

  function installProductOffer() {
    if (!/\/products\//.test(location.pathname)) return;
    const refresh = () => window.requestAnimationFrame(renderProductOffer);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
    else refresh();
    document.addEventListener('change', refresh);
    document.addEventListener('variant:change', refresh);
    window.setTimeout(refresh, 600);
    window.setTimeout(refresh, 1600);
  }

  async function cart() {
    const response = await nativeFetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
      credentials: 'same-origin', headers: { Accept: 'application/json' }
    });
    return response.json();
  }

  function doubleAddPayload(body, contentType) {
    if (body instanceof FormData || body instanceof URLSearchParams) {
      const id = String(body.get('id') || '');
      if (eligible.has(id)) body.set('quantity', String(int(body.get('quantity'), 1) * 2));
      return body;
    }
    if (typeof body === 'string' && contentType.includes('application/json')) {
      const data = JSON.parse(body || '{}');
      if (Array.isArray(data.items)) {
        data.items = data.items.map((item) => eligible.has(String(item.id))
          ? { ...item, quantity: int(item.quantity, 1) * 2 }
          : item);
      } else if (eligible.has(String(data.id || ''))) {
        data.quantity = int(data.quantity, 1) * 2;
      }
      return JSON.stringify(data);
    }
    if (typeof body === 'string') {
      const params = new URLSearchParams(body);
      const id = String(params.get('id') || '');
      if (eligible.has(id)) params.set('quantity', String(int(params.get('quantity'), 1) * 2));
      return params.toString();
    }
    return body;
  }

  function addVariantIds(body, contentType) {
    try {
      if (body instanceof FormData || body instanceof URLSearchParams) return [String(body.get('id') || '')];
      if (typeof body === 'string' && contentType.includes('application/json')) {
        const data = JSON.parse(body || '{}');
        return Array.isArray(data.items) ? data.items.map((item) => String(item.id || '')) : [String(data.id || '')];
      }
      if (typeof body === 'string') return [String(new URLSearchParams(body).get('id') || '')];
    } catch (_) {}
    return [];
  }

  function showAvailabilityNotice() {
    const previous = document.getElementById('bbd-availability-notice');
    if (previous) previous.remove();
    const notice = document.createElement('div');
    notice.id = 'bbd-availability-notice';
    notice.setAttribute('role', 'status');
    notice.textContent = 'Due to availability, only one item was added to your cart.';
    Object.assign(notice.style, {
      position: 'fixed', left: '50%', bottom: '24px', transform: 'translateX(-50%)',
      zIndex: '2147483647', maxWidth: 'calc(100% - 32px)', padding: '14px 18px',
      background: '#1f2937', color: '#fff', borderRadius: '6px', boxShadow: '0 4px 18px rgba(0,0,0,.25)',
      fontSize: '14px', lineHeight: '1.4', textAlign: 'center'
    });
    document.body.appendChild(notice);
    window.setTimeout(() => notice.remove(), 5000);
  }

  function variantTotals(items) {
    const totals = new Map();
    (items || []).forEach((item) => {
      const id = String(item.variant_id);
      totals.set(id, (totals.get(id) || 0) + int(item.quantity, 0));
    });
    return totals;
  }

  async function normalizeOddCart(beforeState) {
    const afterState = await cart();
    const beforeTotals = variantTotals((beforeState && beforeState.items) || []);
    const afterTotals = variantTotals(afterState.items || []);
    const updates = {};

    eligible.forEach((variantId) => {
      const afterTotal = afterTotals.get(variantId) || 0;
      if (!afterTotal || afterTotal % 2 === 0) return;
      const beforeTotal = beforeTotals.get(variantId) || 0;
      const increase = afterTotal >= beforeTotal;
      const candidates = (afterState.items || []).filter((item) => String(item.variant_id) === variantId);
      const item = increase ? candidates[0] : candidates[candidates.length - 1];
      if (!item) return;
      updates[item.key] = Math.max(0, int(item.quantity, 0) + (increase ? 1 : -1));
    });

    if (!Object.keys(updates).length) return null;
    return nativeFetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates })
    });
  }

  window.fetch = async (input, init) => {
    const path = cartPath(typeof input === 'string' ? input : input.url);
    if (!/\/cart\/(add|change|update)(\.js)?$/.test(path)) return nativeFetch(input, init);
    const next = cloneInit(init);
    const contentType = next.headers.get('content-type') || '';
    const isAdd = /\/cart\/add(\.js)?$/.test(path);
    const shouldNotifyLimited = isAdd && addVariantIds(next.body, contentType).some((id) => limited.has(id));
    let beforeState = null;
    try {
      if (isAdd) next.body = doubleAddPayload(next.body, contentType);
      else beforeState = await cart();
    } catch (error) {
      console.warn('[BBD BOGO] Cart synchronization skipped:', error);
    }
    let response = await nativeFetch(input, next);
    if (response.ok && !isAdd && beforeState) {
      try {
        const normalized = await normalizeOddCart(beforeState);
        if (normalized && normalized.ok) response = normalized;
      } catch (error) {
        console.warn('[BBD BOGO] Cart normalization skipped:', error);
      }
    }
    if (response.ok && shouldNotifyLimited) window.setTimeout(showAvailabilityNotice, 100);
    return response;
  };

  async function repairOddCart() {
    try {
      const state = await cart();
      const totals = variantTotals(state.items || []);
      const updates = {};
      eligible.forEach((variantId) => {
        const total = totals.get(variantId) || 0;
        if (!total || total % 2 === 0) return;
        const item = (state.items || []).find((row) => String(row.variant_id) === variantId);
        if (item) updates[item.key] = int(item.quantity, 0) + 1;
      });
      if (!Object.keys(updates).length) return;
      await nativeFetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates })
      });
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      location.reload();
    } catch (error) {
      console.warn('[BBD BOGO] Initial cart synchronization skipped:', error);
    }
  }
  installProductOffer();
  repairOddCart();
})();
